import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import styled from 'styled-components';
import { Placeholder, PlaceholderContent } from '../../components/Placeholder';

const NotFoundMessage = styled.h2`
  text-align: left;
  color: ${p => p.theme.colorGrey};
`;

const NotFound = () => {
  return (
    <Placeholder>
      <PlaceholderContent>
        <NotFoundMessage>
          <FormattedMessage id="containers.NotFound.heading" />
        </NotFoundMessage>
      </PlaceholderContent>
    </Placeholder>
  );
};

export default NotFound;



// WEBPACK FOOTER //
// ./src/containers/NotFound/index.tsx